module.exports = __webpack_public_path__ + "img/bg-qr-code-hub.21cd39e5.svg";